export var CheckpointCategory;
(function (CheckpointCategory) {
    CheckpointCategory["Media"] = "Media";
    CheckpointCategory["Legal"] = "Legal";
    CheckpointCategory["Resume"] = "Resume";
    CheckpointCategory["Financial"] = "Financial";
    CheckpointCategory["Personalia"] = "Personalia";
})(CheckpointCategory || (CheckpointCategory = {}));
